(function () {
  'use strict';
  function update(root) {
    if (document.getElementById('kopero-market-defaults') && document.documentElement.dataset.keMarketReady !== 'true') return;
    var lines = [];
    if (root.matches && root.matches('[data-ke-shipping]')) lines.push(root);
    if (root.querySelectorAll) lines.push.apply(lines, root.querySelectorAll('[data-ke-shipping]'));
    lines.forEach(function (line) {
      var text = line.getAttribute('data-ke-shipping-text');
      if (text && line.textContent !== text) line.textContent = text;
    });
  }
  document.addEventListener('kopero:market-ready', function () { update(document); });
  update(document);
  // Cart sections and product variant content are replaced without navigation.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) { if (node.nodeType === 1) update(node); });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
